import { Card, ListLayout, Spinner } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { CarrierContractDetail } from '../queries';
import { SchemaDisplay } from '../schema/display/schema-display';
import { useCarrierContractCombinedSchemaQuery } from '../schema/queries';

interface Props {
  contract: CarrierContractDetail;
}

export function Configuration({ contract }: Props) {
  const { data: schema, isLoading } = useCarrierContractCombinedSchemaQuery(contract);
  const { t } = useTranslation();

  if (isLoading || !schema) {
    return <Spinner />;
  }

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.credentials')}</Card.Header>

      <Card.Content>
        <ListLayout.Column>
          {Object.entries(schema.json_schema).map(([key, value]) => (
            <SchemaDisplay
              path={`carrier_configuration_data.${key}`}
              schemaId={contract.schema_id!}
              schema={value}
              key={key}
            />
          ))}
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
